import React, {useEffect, useState} from 'react';
import GroupForm, {tempCounterData} from "../../components/GroupForm";
import {Helmet} from "react-helmet";
import BlockUi from "@availity/block-ui";
import axios from "../../../../helpers/axios";
import {useNavigate} from "react-router";
import {RacoonGroupListRoute} from "../../../routesConstants";


const tempData = {
  startDate:'',
  endDate:'',
  name:'',
  googleSheetId:'',
  counterparties:[tempCounterData],
  typeRacoon : "Рабочий",
  routeType:'iata',
  blackList: []
}
const CreateGroup = () => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const navigate = useNavigate()

  const onSubmit = (data) =>{
    setLoading(true)
    axios.put('/api/racoon/revise/group', data)
      .then(()=>{
        navigate(RacoonGroupListRoute)
      })
      .finally(()=>setLoading(false))
  }

  useEffect(() => {
    const groupCopied = localStorage.getItem("groupCopied")
    console.log(groupCopied)
    if(groupCopied){
      setData(JSON.parse(groupCopied))
      localStorage.removeItem("groupCopied")
    }else{
      setData(tempData)
    }
  }, []);
  return (
    <>
      <Helmet><title>Создание группы</title></Helmet>
      <BlockUi blocking={loading}>
        {data && <GroupForm data={data} cb={onSubmit}/>}
      </BlockUi>
    </>
  );
};

export default CreateGroup;
